import { render } from "./ItemDetail.vue?vue&type=template&id=909724da&scoped=true&ts=true"
import script from "./ItemDetail.vue?vue&type=script&lang=ts"
export * from "./ItemDetail.vue?vue&type=script&lang=ts"

import "./ItemDetail.vue?vue&type=style&index=0&id=909724da&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src613357358/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-909724da"]])

export default __exports__